import type { Team } from '@/entities/team';
import request from '@/shared/api/request';

export const updateTeam = (
  uuid: string,
  data: { name: string; color: string },
): Promise<{ team: Team }> =>
  request({
    url: `/teams/${uuid}/`,
    method: 'PUT',
    data,
  });
